import { Gruppe } from '../../classes/gruppe';

export class GruppeSchweinDialogInput {
    kunde_id: number;
    betriebsart_id: number;
    gruppe: Gruppe;
    showAnzahlDatumGewicht = true;

    constructor(
        kunde_id: number,
        betriebsart_id: number,
        options?: { gruppe?: Gruppe; showAnzahlDatumGewicht?: boolean },
    ) {
        this.kunde_id = kunde_id;
        this.betriebsart_id = betriebsart_id;
        this.gruppe = options?.gruppe;
        if (options?.showAnzahlDatumGewicht === false) {
            this.showAnzahlDatumGewicht = false;
        }
    }
}
